<template>
    <div class="loading-backdrop">
        <div class="inner">
            <div class="loader-wrapper"><span class="loader red"></span></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Loading'
    }
</script>

<style lang="scss">
    .loading-backdrop{
        position: fixed;
        top: 0; left: 0;
        width: 100%;
        height: 100%;
        /*background: rgba(228,3,11, .1);*/
        /*background: rgba(255,255,255, .5);*/
        background: transparent ;
        overflow: hidden;
        z-index: 10000;
        .inner{
            position: absolute;
            top: 50%; left: 50%;
            transform: translate(-50%, -50%);
        }
    }
</style>